module.exports = __webpack_public_path__ + "static/fonction3-7946e40b6269c7d49d6736dcada84dc4.jpg";